import { Command } from '@/plugins/cad/module/core/Command'
import type { CADViewManager } from '../manager/CADViewManager'
import { EntityType } from '../model/common/constant'
import type { IEntity, PolylineEntity } from '../model/entity'

/**
 * 闭合多段线命令，将目标实体的 isClosed 置为 true，支持撤销/重做。
 */
export class CloseEntityCommand extends Command {
  private entities: IEntity[] = []
  /** 保存每个实体闭合前的原始状态，用于 undo */
  private originClosedStates: Map<string, boolean> = new Map()

  constructor(private viewManager: CADViewManager) {
    super()
  }

  /** 实际闭合操作在 addEntities 中完成，这里为空实现 */
  execute(): void {
    // 在addEntities中已处理
  }

  /** 撤销：将实体闭合状态还原为执行前 */
  undo(): void {
    this.entities.forEach((entity) => {
      if (!this.originClosedStates.has(entity.id)) {
        return
      }
      this.handleEntity(entity, this.originClosedStates.get(entity.id)!, false)
    })
    this.viewManager.updateEntities(this.entities, { updateGeometry: true })
  }

  /** 重做：重新将实体置为闭合 */
  redo(): void {
    this.entities.forEach((entity) => {
      this.handleEntity(entity, true, false)
    })
    this.viewManager.updateEntities(this.entities, { updateGeometry: true })
  }

  /**
   * 是否允许提交命令。
   *
   * @returns 存在已处理实体时返回 true
   */
  canCommit(): boolean {
    return this.entities.length > 0
  }

  /**
   * 追加一批实体并立即闭合，会记录原始状态供 undo 使用。
   *
   * @param entities - 待闭合的实体集合
   */
  addEntities(entities: IEntity[]) {
    const updateEntities: IEntity[] = []
    // 闭合处理
    entities.forEach((entity) => {
      if (this.originClosedStates.has(entity.id)) {
        return
      }
      if (this.handleEntity(entity, true, true)) {
        updateEntities.push(entity)
      }
    })
    this.entities.push(...updateEntities)
    this.viewManager.updateEntities(updateEntities, { updateGeometry: true })
  }

  private handleEntity(entity: IEntity, newState: boolean, isRecord = true): boolean {
    if (entity.type === EntityType.Polyline) {
      const currentEntity = entity as PolylineEntity
      isRecord && this.originClosedStates.set(currentEntity.id, currentEntity.isClosed)
      currentEntity.isClosed = newState
      return true
    }
    return false
  }
}
